import { render, staticRenderFns } from "./PdfViewModal.vue?vue&type=template&id=46ac72f3"
import script from "./PdfViewModal.vue?vue&type=script&lang=js"
export * from "./PdfViewModal.vue?vue&type=script&lang=js"
import style0 from "./PdfViewModal.vue?vue&type=style&index=0&id=46ac72f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports